import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToggleComponent } from '../../../../components/ui/toggle/toggle.component';

interface PlannedAlert {
  title: string;
  description: string;
}

/**
 * Notification preferences have no backend yet, so this page says so plainly
 * and shows the planned alerts with their switches turned off and locked.
 * It is not linked from the settings tabs; the URL still opens it.
 */
@Component({
  selector: 'app-notifications-settings',
  standalone: true,
  imports: [CommonModule, ToggleComponent],
  templateUrl: './notifications-settings.component.html',
  styleUrls: ['../settings-ui.css', './notifications-settings.component.css'],
})
export class NotificationsSettingsComponent {
  readonly alerts: PlannedAlert[] = [
    {
      title: 'Message delivery report ready',
      description: 'An email when the delivery report for a message you sent is ready.',
    },
    {
      title: 'Campaign sent',
      description: 'An email when a campaign you scheduled has gone out.',
    },
    {
      title: 'Scheduled send reminder',
      description: 'A reminder shortly before a scheduled message or campaign goes out.',
    },
    {
      title: 'New contact group created',
      description: 'An email when someone creates a contact group in your organization.',
    },
    {
      title: 'New contact added',
      description: 'An email when a contact is added to your organization.',
    },
    {
      title: 'Weekly engagement digest',
      description: 'A weekly summary of sends, delivery and contact activity.',
    },
  ];
}
